"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var tv4 = require('tv4');

var FileReference = require('./file-reference');

var Card = /*#__PURE__*/function () {
  function Card(opt) {
    _classCallCheck(this, Card);

    this.id = null;
    this.type = null;
    this.attachments = [];
    this.comment = null;
    this.isRequired = false;
    this.isMovable = true;
    this.isEditable = true;
    this.allowAttachments = true;
    this.allowComment = false;
    this.label = {};
    this.isValid = true;

    if (opt) {
      this.fillBaseObject(opt);
    }
  }

  _createClass(Card, [{
    key: "fillBaseObject",
    value: function fillBaseObject(opt) {
      var _this = this;

      this.id = new ObjectId(opt.id);
      this.type = opt.type || null;

      var checkBoolean = function checkBoolean(property, fallback) {
        return typeof property === 'boolean' ? property : fallback;
      };

      this.allowAttachments = checkBoolean(opt.allowAttachments, this.allowAttachments);
      this.allowComment = checkBoolean(opt.allowComment, this.allowComment);
      this.isEditable = checkBoolean(opt.isEditable, this.isEditable);
      this.isMovable = checkBoolean(opt.isMovable, this.isMovable);
      this.isRequired = checkBoolean(opt.isRequired, this.isRequired);

      if (opt.attachments) {
        opt.attachments.forEach(function (attachment) {
          return _this.attachments.push(new FileReference(attachment));
        });
      }

      this.comment = opt.comment !== null && opt.comment !== undefined ? opt.comment : this.comment;
      this.label = opt.label || {};
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Card.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'card.schema.json',
        type: 'object',
        properties: {
          id: {
            type: ['object', 'null']
          },
          type: {
            type: 'string'
          },
          attachments: {
            type: 'array',
            items: {
              $ref: 'file-reference.schema.json'
            }
          },
          comment: {
            type: ['string', 'null']
          },
          isRequired: {
            type: 'boolean'
          },
          isMovable: {
            type: 'boolean'
          },
          isEditable: {
            type: 'boolean'
          },
          allowAttachments: {
            type: 'boolean'
          },
          allowComment: {
            type: 'boolean'
          },
          label: {
            type: 'object'
          },
          isValid: {
            type: 'boolean'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return Card;
}();

tv4.addSchema(FileReference.schema());
module.exports = Card;